<template>
  <div class="analytics-menu">
    <div v-if="!isLoading" class="analytics-menu__tabs">
      <template v-for="tab in mainTabs">
        <router-link
          v-if="isAnalyticsAvailable(tab.key)"
          :key="tab.key"
          :to="{ name: tab.route }"
          class="analytics-menu__tab"
          active-class="is-active"
          exact-active-class="is-active"
        >
          <div class="analytics-menu__icon">
            <img :src="tab.icon" alt="">
          </div>

          <div class="analytics-menu__text">
            <div class="analytics-menu__title">
              {{ tab.title }}
            </div>
            <div class="analytics-menu__desc">
              {{ tab.desc }}
            </div>
          </div>
        </router-link>

        <div
          v-else
          :key="tab.key + '_disabled'"
          class="analytics-menu__tab is-disabled"
        >
          <div class="analytics-menu__icon">
            <img :src="tab.icon" alt="">
          </div>

          <div class="analytics-menu__text">
            <div class="analytics-menu__title">
              {{ tab.title }}
            </div>
            <div class="analytics-menu__desc">
              {{ tab.desc }}
            </div>
          </div>

          <button
            v-if="showButton"
            class="analytics-menu__promo-btn"
            type="button"
            @click="openPromo(tab.key)"
          >
            Подключить услугу
          </button>
        </div>
      </template>
    </div>

    <div
      v-if="isLoading"
      class="analytics-menu__loading"
    >
      <SpinnerLoading v-if="isLoading" class="loader_center" color="blue" />
    </div>

    <template v-else-if="actualAnalytics.length === 0">
      <div class="analytics-menu__empty">
        <img src="@/assets/img/icons/message.png" alt="" class="analytics-menu__empty-icon">
        <div class="analytics-menu__empty-subtitle">
          У Вас нет подключенных камер с аналитикой
        </div>
      </div>
      <div class="analytics-menu__empty-spacer" />
    </template>

    <router-view v-else />
  </div>
</template>

<script>
import {
  ROUTE_ANALYTICS,
  ROUTE_PACS_CAR_NUMBER_ANALYTICS,
  ROUTE_PACS_HELMET_ANALYTICS,
  ROUTE_PACS_MASK_ANALYTICS,
  ROUTE_PACS_CROWD_ANALYTICS,
  ROUTE_PACS_PERIMETER_SECURITY_ANALYTICS,
  ROUTE_PACS_FALL_DETECTION_ANALYTICS,
  ROUTE_PACS_PEOPLE_COUNT_ANALYTICS,
  ROUTE_PACS_PARKING_DETECTION_ANALYTICS
} from "@/router/names.js";

import {ACTION_LOAD_AVAILABLE_ANALYTICS} from "@/store/analytics/index.js";
import PromoAnalyticsDialog from "@/components/pacs/PromoAnalyticsDialog.vue";
import {VENDOR_IS_UFANET} from "@/utils/consts.js";

export default {
  name: "PacsAnalyticsSettingsFrame",
  data() {
    return {
      showButton: false,
      isLoading: true,
      availableAnalytics: [],
      routes: {
        ROUTE_PACS_CAR_NUMBER_ANALYTICS,
        ROUTE_PACS_HELMET_ANALYTICS,
        ROUTE_PACS_MASK_ANALYTICS,
        ROUTE_PACS_CROWD_ANALYTICS,
        ROUTE_PACS_PERIMETER_SECURITY_ANALYTICS,
        ROUTE_PACS_FALL_DETECTION_ANALYTICS,
        ROUTE_PACS_PEOPLE_COUNT_ANALYTICS,
        ROUTE_PACS_PARKING_DETECTION_ANALYTICS
      },
    };
  },
  mounted() {
    this.isLoading = true;
    this.$store.dispatch(`analytics/${ACTION_LOAD_AVAILABLE_ANALYTICS}`).then((analytics) => {
      this.availableAnalytics = analytics;
      this.redirectIfNeeded();
    }).finally(() => {
      this.isLoading = false;
    });
    this.showButton = VENDOR_IS_UFANET;
  },
  methods: {
    redirectIfNeeded() {
      if (this.$route.name !== ROUTE_ANALYTICS) return;
      // Находим первую аналитику, которая есть в actualAnalytics
      const firstAvailable = this.actualAnalytics[0];
      if (firstAvailable) {
        const routeMap = {
          'people_counter': this.routes.ROUTE_PACS_PEOPLE_COUNT_ANALYTICS,
          'perimeter_security': this.routes.ROUTE_PACS_PERIMETER_SECURITY_ANALYTICS,
          'fall_detection': this.routes.ROUTE_PACS_FALL_DETECTION_ANALYTICS,
          'crowd': this.routes.ROUTE_PACS_CROWD_ANALYTICS,
          'parking_detection': this.routes.ROUTE_PACS_PARKING_DETECTION_ANALYTICS,
        };
        const targetRoute = routeMap[firstAvailable];
        if (targetRoute) {
          this.$router.replace({name: targetRoute});
        }
      }
    },
    isAnalyticsAvailable(analyticsKey) {
      return (this.availableAnalytics || []).includes(analyticsKey);
    },
    openPromo(analyticsKey) {
      this.$camsdals.open(
        PromoAnalyticsDialog,
        {analyticsKey},
        {dialogTitle: "Подключение услуг"},
        {size: "vuedal-auto-width"}
      );
    }
  },
  computed: {
    actualAnalytics() {
      const supportedKeys = [
        'people_counter',
        'perimeter_security',
        'fall_detection',
        'crowd',
        'parking_detection'
      ];
      return (this.availableAnalytics || []).filter(key => supportedKeys.includes(key));
    },
    mainTabs() {
      const promoTabsKeys = ['people_counter', 'perimeter_security', 'crowd'];
      const optionalTabsKeys = ['fall_detection', 'parking_detection'];

      const tabs = [
        {
          key: 'people_counter',
          route: this.routes.ROUTE_PACS_PEOPLE_COUNT_ANALYTICS,
          icon: require('@/assets/img/people_counter.png'),
          title: 'Подсчет посетителей',
          desc: 'Узнайте сколько человек к вам пришло',
        },
        {
          key: 'perimeter_security',
          route: this.routes.ROUTE_PACS_PERIMETER_SECURITY_ANALYTICS,
          icon: require('@/assets/img/perimeter_security.png'),
          title: 'Вторжение в зону',
          desc: 'Мы оповестим о появлении людей в заданной вами области',
        },
        {
          key: 'fall_detection',
          route: this.routes.ROUTE_PACS_FALL_DETECTION_ANALYTICS,
          icon: require('@/assets/img/perimeter_security.png'),
          title: 'Обнаружение падений',
          desc: 'Мы оповестим о падении человека в заданной вами области',
        },
        {
          key: 'crowd',
          route: this.routes.ROUTE_PACS_CROWD_ANALYTICS,
          icon: require('@/assets/img/crowd.png'),
          title: 'Детекция очереди',
          desc: 'Следите за пополнениями очередей и оповещайте своих сотрудников',
        },
        {
          key: 'parking_detection',
          route: this.routes.ROUTE_PACS_PARKING_DETECTION_ANALYTICS,
          icon: require('@/assets/img/icons/icon-car.svg'),
          title: 'Детекция парковки',
          desc: 'Следите за наличием свободных мест на парковке',
        }
      ].filter(tab => {
        if (promoTabsKeys.includes(tab.key)) return true;
        if (optionalTabsKeys.includes(tab.key)) return this.isAnalyticsAvailable(tab.key);
        return false;
      });

      return tabs.sort((a, b) => {
        const aAvailable = this.isAnalyticsAvailable(a.key);
        const bAvailable = this.isAnalyticsAvailable(b.key);
        if (aAvailable === bAvailable) return 0;
        return aAvailable ? -1 : 1;
      });
    }
  }
};
</script>
<style lang="scss">
.analytics-menu {
  display: flex;
  flex-direction: column;
  height: 100%;

  &__tabs {
    display: flex;
    gap: 24px;
    padding-bottom: 10px;
    flex-shrink: 0;
  }

  &__tab {
    position: relative;
    flex: 1 1 0;
    min-width: 0;

    display: flex;
    align-items: center;
    gap: 18px;

    padding: 16px 20px;
    border-radius: 14px;

    border: 2px solid transparent;

    text-decoration: none;
    color: inherit;

    transition: border-color 0.15s ease, background-color 0.15s ease;
  }

  &__tab.is-active {
    background: #fff;
    border-color: #2f84f8;

  }
  &__tab.is-disabled {
    cursor: default;
    overflow: hidden;
  }
  .analytics-menu__icon,
  .analytics-menu__text {
    opacity: 1;
  }
  &__icon {
    flex: 0 0 72px;
    width: 72px;
    height: 72px;
    border-radius: 14px;

    display: flex;
    align-items: center;
    justify-content: center;
    opacity: 0.5;
    transition: opacity 0.15s ease;
  }

  &__text {
    min-width: 0;
    display: flex;
    flex-direction: column;
    opacity: 0.5;
    transition: opacity 0.15s ease;
  }

  &__title {
    font-size: 14px;
    line-height: 1.2;
    font-weight: 700;
    color: #1f2a37;

    margin: 0 0 6px 0;

    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }

  &__desc {
    font-size: 14px;
    line-height: 1.4;
    color: #6b7280;

    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;

    min-height: calc(1.4em * 2);
  }
}

.analytics-menu__icon svg,
.analytics-menu__icon img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.analytics-menu__promo-btn {
  position: absolute;
  right: 8px;
  top: 8px;
  z-index: 10;

  padding: 6px 10px;
  border-radius: 9px;
  background: #2f84f8;
  color: #fff;
  border: none;
  font-weight: 700;
  cursor: pointer;
  box-shadow: 0 4px 10px rgba(47, 132, 248, 0.4);
  transition: all 0.2s ease;
  opacity: 0.5;


  &:hover {
    opacity: 0.9;

    background: #2f84f8;
    transform: translateY(-2px);
    box-shadow: 0 6px 14px rgba(47, 132, 248, 0.5);
  }

  &:active {
    transform: translateY(0);
  }
}

.analytics-menu__empty {
  display: flex;
  flex: 8 1 0;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  background-color: #EDF1F7;
  border-radius: 24px;
  opacity: 1;
}

.analytics-menu__empty-icon {
  width: 48px;
  height: 48px;
  margin-bottom: 24px;
}

.analytics-menu__empty-title {
  font-size: 16px;
  font-weight: 700;
  color: #111;
  margin-bottom: 8px;
}

.analytics-menu__empty-subtitle {
  font-size: 14px;
  color: #6b7280;
}

.analytics-menu__empty-spacer {
  flex: 1 1 0;
}
</style>
